'use strict';
const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * TwitterEmbed
     *
     * This web component will lazy-load wrapped Twitter embeds. Once an
     * embed is scrolled into view, the tweet markup will be inserted, and
     * the Twitter embed script will be added to the page. It also checks
     * the GDPR status.
     *
     * @example
     *   <phoenix-twitter-embed tweet-url="https://twitter.com/..."></phoenix-twitter-embed>
     */
    class TwitterEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            this.tweetUrl = this.getAttr('tweet-url', { required: true });

            this.canRender().then((canRender) => {
                if (canRender) {
                    this.observeFirstIntersection();
                }
            });
        }

        onFirstIntersection() {
            const html = `<blockquote class="twitter-tweet"><a href="${this.tweetUrl}"/></blockquote>`;
            pageClass.util
                .addScriptResourceOnce('https://platform.twitter.com/widgets.js', { id: 'twitter-widgets' })
                .then(() => {
                    this.innerHTML = html;
                    // Call the Twitter API on this particular document fragment:
                    // https://dev.twitter.com/web/javascript/initialization#init
                    window.twttr.widgets.load(this);
                });
        }
    }
    window.customElements.define('phoenix-twitter-embed', TwitterEmbed);
});
